import Service, { service } from '@ember/service';
import type { Store as StoreService } from '@warp-drive/core';

import type { MatchPayment as MatchPaymentModel } from 'tio-data/data/resources/match-payment.type';
import { certifyMatchPaymentsRequest } from 'tio-data/requests/match-payment';

export default class MatchPaymentService extends Service {
  @service declare store: StoreService;

  async certifyMatchPayments(payments: Array<MatchPaymentModel>) {
    const ids = payments.map((p) => p.id).filter((id): id is string => typeof id === 'string');
    const response = await this.store.request(certifyMatchPaymentsRequest(ids));
    const { data } = response.content as { data: unknown };
    // The request is SkipCache, so the certified records aren't auto-inserted —
    // push the already-normalized JSON:API document directly (no serializer).
    this.store.push({ data } as Parameters<StoreService['push']>[0]);
  }
}
